<div class="row" class="release-notes-content">
    <div class="col">
        <nav>
            <ul class="nav nav-tabs">
                <li class="nav-item pe-1">
                    <a class="nav-link" jhiTranslate="release-notes.nav.notes"
                       [routerLink]="['content']" [routerLinkActive]="['active']"  [queryParams]="{fileName: releaseNoteFileName}"  queryParamsHandling="merge"></a>
                </li>
                <li class="nav-item pe-1" *ngIf="hasComingSoon">
                    <a class="nav-link" jhiTranslate="release-notes.nav.coming-soon"
                       [routerLink]="['coming-soon']" [routerLinkActive]="['active']" [queryParams]="{fileName: comingSoonFileName}" queryParamsHandling="merge"></a>
                </li>
            </ul>
        </nav>
        <div class="tab-content p-3">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>
